import { useEffect, useState } from "react";
import { Pagination } from "../../../components/Pagination";
import { getNews } from "../../../api/transport/newsTransport";
import { NewsDto, NewsFilter } from "../../../types/news";
import { extractTextFromHtml, getSiteByTeamCode, getStaticUrl, getUrlByContext, setDocumentTitle, updateHashParams } from "../../../utils";
import { LoadingNewsCard, NewsCard } from "../../../components/news/NewsCard";
import { PaginationResponse, SiteType, TeamContext } from "../../../types/common";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { NewsCategories } from "./NewsCategories";

const NEWS_PER_PAGE = 9;

const NewsPage: React.FC = () => {
    const [news, setNews] = useState<PaginationResponse<NewsDto>>();
    const [selectedCategory, setSelectedCategory] = useState(-1);
    const [loading, setLoading] = useState(true);
    const config = useConfiguration();

    const loadPage = (p: number = 0, filter?: NewsFilter) => {
        setLoading(true);
        getNews(p, NEWS_PER_PAGE, getSiteByTeamCode(config.teamName), filter).then((n) => {
            setNews(n);
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(globalThis.location.search.slice(1));
        const pageParam = searchParams.get('p') || 0;
        let page = 0;
        if (pageParam) {
            page = +pageParam / NEWS_PER_PAGE;
        }

        let category = searchParams.get('c');

        if (!category) {
            if (config.teamName === TeamContext.RODINA_2) {
                category = '8';
            } else if (config.teamName === TeamContext.RODINA_3) {
                category = '13';
            } else if (config.teamName === TeamContext.RODINA_M) {
                category = '6';
            } else if (config.teamName === TeamContext.ACADEMY) {
                category = '2';
            }
        }

        if (category) {
            setSelectedCategory(+category);
        }

        setLoading(true);
        loadPage(page, category ? { id_cat: +category } : null);
    }, []);

    useEffect(() => {
        setDocumentTitle(`Новости - Официальный сайт ${config.site === SiteType.LEGACY_ACADEMY ? "Академия" : "ФК"} «Родина»`);
    }, [config.site]);

    let newsCards = null;

    if (loading) {
        const cards = [];

        for (let i = 0; i < NEWS_PER_PAGE; i++) {
            cards.push(<LoadingNewsCard key={`loder_${i}`} />);
        }

        newsCards = (
            <>
                {cards}
            </>
        );
    } else if (news?.data?.length) {
        newsCards = news?.data?.map((n) => {
            const content = extractTextFromHtml(n.description).split('.')[0];
            const imageUrl = getSiteByTeamCode(config.teamName) === SiteType.LEGACY_ACADEMY ? n.image : getStaticUrl(n.image);
            return (
                <NewsCard
                    key={n.id}
                    url={getUrlByContext(n.url, config.teamName)}
                    cover={imageUrl}
                    title={n.title}
                    date={n.date}
                    //content={content}
                    category={n.category}
                />
            )
        });
    } else {
        newsCards = (
            <div className="italic w-full h-full p-8 text-center min-h-96 flex flex-col items-center justify-center">Не найдено новостей в выбранной категории</div>
        );
    }

    const setCurrentPage = (p: number) => {
        //loadPage(p);
    }

    const onPageChange = (page: number) => {
        /*updateHashParams({
            p: page.toString(),
        });*/
        const searchParams = new URLSearchParams(globalThis.location.search.slice(1));
        const startItem = page * NEWS_PER_PAGE;
        if (startItem === 0) {
            searchParams.delete('p');
        } else {
            searchParams.set('p', startItem.toString());
        }
        const search = searchParams.size > 0 ? ('?' + searchParams) : '';
        if (search) {
            globalThis.location.assign(search)
        } else {
            globalThis.location.assign(globalThis.location.pathname);
        }
        setCurrentPage(page);
    }

    const onCategorySelect = (categoryId: number) => {
        if (categoryId > 0) {
            globalThis.location.assign('?c=' + categoryId);
        } else {
            globalThis.location.assign(globalThis.location.pathname);
        }
    }

    return (
        <div className="w-full pt-8 pb-8 bg-white max-w-[1024px] mx-auto">
            <NewsCategories onSelect={onCategorySelect} defaultSelectedId={selectedCategory} />
            <div className="grid pb-8 justify-center gap-3 sm:gap-8" style={{ gridTemplateColumns: 'repeat(auto-fit, 300px)' }}>
                {newsCards}
            </div>
            {!loading && (
                <>
                    <div className="hidden sm:block" key="pagination">
                        <Pagination
                            totalPages={news.totalPages}
                            currentPage={news.page}
                            onChange={onPageChange}
                            endButtons={news.totalPages > 6}
                        />
                    </div>
                    <div className="sm:hidden" key="pagination:sm">
                        <Pagination
                            totalPages={news.totalPages}
                            currentPage={news.page}
                            onChange={onPageChange}
                            endButtons={news.totalPages > 3}
                            maxPages={3}
                        />
                    </div>
                </>
            )}
        </div>
    );
}

export default NewsPage;